import {srcUrl} from "@/api/ImageApi.ts";
import question from "@assets/question.svg";
import {Spell, SpellSummary} from "@/spells/model/Spell.ts";

export default function SpellImage({spell, size,}: { spell: Spell | SpellSummary, size: number, }) {
    return (
        <div className={`flex-none bg-white overflow-hidden rounded-xs}`}
             style={{width: size, height: size}}>
            {spell.image &&
                <img draggable="false" alt=""
                     className="size-full select-none object-contain"
                     src={srcUrl(spell.image)}
                />}
            {!spell.image &&
                <img draggable="false" alt=""
                     className={"size-full scale-90 select-none object-contain"}
                     src={question}/>}
        </div>
    )
}
